import { useRef, useState } from "react";
import Button from "../ui/Button";
import Checkbox from "../ui/Checkbox";
import "./AuthForm.css"; // reuse heading, spacing, etc.

const DIGITS = 4;

export default function TwoFactorForm({ onSubmit, onResend }) {
    const [code, setCode] = useState(Array(DIGITS).fill(""));
    const [acknowledged, setAcknowledged] = useState(false);
    const inputsRef = useRef([]);

    const setCell = (i, v) => {
        const next = [...code];
        next[i] = v;
        setCode(next);
    };

    const handleChange = (i) => (e) => {
        const val = e.target.value.replace(/\D/g, "").slice(-1); // only one digit
        setCell(i, val);
        if (val && i < DIGITS - 1) inputsRef.current[i + 1]?.focus();
    };

    const handleKeyDown = (i) => (e) => {
        if (e.key === "Backspace" && !code[i] && i > 0) {
            inputsRef.current[i - 1]?.focus();
            setCell(i - 1, "");
        }
        if (e.key === "ArrowLeft" && i > 0) inputsRef.current[i - 1]?.focus();
        if (e.key === "ArrowRight" && i < DIGITS - 1) inputsRef.current[i + 1]?.focus();
    };

    const handlePaste = (e) => {
        const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, DIGITS).split("");
        if (!pasted.length) return;
        e.preventDefault();
        const next = Array(DIGITS).fill("");
        pasted.forEach((d, idx) => (next[idx] = d));
        setCode(next);
        const last = Math.min(pasted.length, DIGITS) - 1;
        inputsRef.current[last]?.focus();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const joined = code.join("");
        if (!acknowledged || joined.length !== DIGITS) return;
        onSubmit?.(joined);
    };

    return (
        <form className="auth-form" onSubmit={handleSubmit}>
            <div style={{ display: "flex", justifyContent: "center" }}>
                <div className="reset-icon">
                    <img src="/icons/mail.png" alt="Mail icon" />
                </div>
            </div>

            <h2>Two-factor<br />Authenticatie</h2>
            <p>
                We hebben een verificatie code gemaild naar<br />
                het door jou opgegeven e-mailadres
            </p>

            <label className="auth-label" style={{ alignSelf: "flex-start" }}>Secure code</label>

            <div className="otp-row">
                {code.map((val, i) => (
                    <input
                        key={i}
                        ref={(el) => (inputsRef.current[i] = el)}
                        value={val}
                        onChange={handleChange(i)}
                        onKeyDown={handleKeyDown(i)}
                        onPaste={handlePaste}
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength={1}
                        className="otp-input"
                        aria-label={`Digit ${i + 1}`}
                    />
                ))}
            </div>

            <Checkbox
                name="privacyAcknowledgement"
                label="Ik ben me ervan bewust dat ik toegang krijg tot privacy gevoelige informatie."
                checked={acknowledged}
                onChange={(e) => setAcknowledged(e.target.checked)}
            />

            <Button type="submit" variant="primary" fullWidth disabled={!acknowledged}>
                Login
            </Button>


            <div style={{ display: "flex" }}>
                <p className="subtle">
                    Geen code ontvangen?{" "}
                    <a type="button" className="link-like" onClick={() => onResend?.()}>
                        Klik om opnieuw te ontvangen
                    </a>
                </p>
            </div>

            <a href="/login" className="forgot-link gray">← Terug naar Login</a>
        </form>
    );
}
